export default __webpack_public_path__ + "static/media/img1.3570db1c.gif";